import { onboarding as en_onboarding } from "../en/onboarding";

/** onboarding — RU slice (29 keys). */
export const onboarding: Record<keyof typeof en_onboarding, string> = {
  onboarding_name_title: "Как тебя зовут?",
  onboarding_name_description: "Так тебя будут видеть другие в Linqx.",
  onboarding_birthdate_title: "Когда у тебя день рождения?",
  onboarding_birthdate_description:
    "Твой возраст будет виден в профиле. Тебе должно быть не меньше 18.",
  onboarding_gender_title: "Какой у тебя пол?",
  onboarding_gender_description: "Это поможет нам подобрать тебе пары получше.",
  onboarding_location_title: "Включи геолокацию",
  onboarding_location_description:
    "Мы используем геолокацию, чтобы находить пары рядом с тобой.",
  onboarding_location_button: "Включить геолокацию",
  onboarding_notifications_title: "Будь в курсе",
  onboarding_notifications_description:
    "Получай уведомления о новых парах и сообщениях.",
  onboarding_notifications_button: "Да, уведомляйте меня",
  onboarding_interests_title: "Интересы",
  onboarding_interests_description:
    "Расскажи всем, чем ты увлекаешься — добавь интересы в свой профиль.",
  onboarding_photos_title: "Загрузи свои фото",
  onboarding_photos_description:
    "Классные фото повысят шанс найти новых друзей.",
  onboarding_photos_description_sub: "Добавь хотя бы 2 фото, чтобы продолжить",
  onboarding_photos_main_badge: "Главное",
  onboarding_photos_main_hint: "Первое фото — это твоё главное фото профиля.",
  onboarding_photos_main_required_title: "Добавь главное фото",
  onboarding_photos_main_required:
    "Добавь главное фото (первый слот), прежде чем покинуть этот шаг.",
  onboarding_rules_description: "Правила сообщества",
  onboarding_rules_button: "Начать",
  onboarding_rule_1_title: "Будь собой.",
  onboarding_rule_1_description:
    "Убедись, что твои фото, возраст и описание — это действительно про тебя.",
  onboarding_rule_2_title: "Береги себя.",
  onboarding_rule_2_description: "Не спеши делиться личной информацией.",
  onboarding_rule_3_title: "Будь на позитиве.",
  onboarding_rule_3_description:
    "Уважай других и относись к ним так, как хотел бы, чтобы относились к тебе.",
  onboarding_rule_4_title: "Будь активным.",
  onboarding_rule_4_description: "Всегда сообщай о плохом поведении.",
};
